import atimg1 from '../images/team/img-1.jpg'
import atimg2 from '../images/team/img-2.jpg'
import atimg3 from '../images/team/img-3.jpg'
import atimg4 from '../images/team/img-4.jpg'
import atimg5 from '../images/team/img-4.jpg'


const Attorneys = [
   {
      Id:'1',
      AtImg:atimg1,
      name:'Lambert Quinn',
      title:'Managing Partner',     
   },
   {
      Id:'2',
      AtImg:atimg2,
      name:'Irene Quick',
      title:'Partner',     
   },
   {
      Id:'3',
      AtImg:atimg3,
      name:'Ryder Moore',
      title:'Partner',     
   },
   {
      Id:'4',
      AtImg:atimg4,
      name:'Rachel Slearn',
      title:'Associate',     
   },
   {
      Id:'5',
      AtImg:atimg5,
      name:'Amy Bott',
      title:'Associate',     
   }
    
]

export default Attorneys;